import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import DINBold from "./DINNextLTPro-Bold.woff2";

export const NunitoFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: DINBold,
    descriptors: {
      unicodeRange: "U+0020-10FFFF",
      weight: "700",
    },
  },
];
